import React from "react";

export default function OverflowPanelModal({
  overflowPanel,
  overflowTitle,
  setOverflowPanel = () => {},
  setOverflowTitle = () => {},
  PlannerShiftCard,
  now,
  selectedShiftId = "",
  selectedShiftIds = [],
  toggleShiftSelection = () => {},
  setSelectedShiftId = () => {},
  workersByUid = new Map(),
  shortWorkerLabel = () => "",
  LifecycleBoxes,
}) {
  if (!overflowPanel || !overflowPanel.length) return null;

  const closePanel = () => {
    setOverflowPanel(null);
    setOverflowTitle("");
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15,23,42,.52)",
        zIndex: 1000,
        display: "grid",
        placeItems: "center",
        padding: 14,
        backdropFilter: "blur(4px)",
      }}
      onMouseDown={closePanel}
    >
      <div
        style={{
          width: "min(640px, 100%)",
          maxHeight: "82vh",
          overflow: "hidden",
          background: "#ffffff",
          borderRadius: 18,
          border: "1px solid #d8e1ea",
          boxShadow: "0 24px 70px rgba(15,23,42,.30)",
          display: "flex",
          flexDirection: "column",
        }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div
          style={{
            padding: "12px 14px",
            borderBottom: "1px solid #e9eef5",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 10,
            background: "linear-gradient(180deg,#ffffff 0%,#f8fafc 100%)",
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              <div style={{ fontWeight: 950, fontSize: 15, color: "#0f172a" }}>
                Overflow shifts
              </div>

              <span
                style={{
                  borderRadius: 999,
                  padding: "4px 9px",
                  fontSize: 11,
                  fontWeight: 900,
                  background: "#eff6ff",
                  border: "1px solid #bfdbfe",
                  color: "#1d4ed8",
                }}
              >
                {overflowPanel.length}
              </span>
            </div>

            <div
              style={{
                fontSize: 12,
                fontWeight: 800,
                color: "#64748b",
                marginTop: 3,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: 430,
              }}
            >
              {overflowTitle || "Additional shifts"}
            </div>
          </div>

          <button
            type="button"
            onClick={closePanel}
            style={{
              borderRadius: 999,
              padding: "7px 12px",
              minHeight: 0,
              fontSize: 12,
              fontWeight: 900,
              background: "#ffffff",
              border: "1px solid #cbd5e1",
              color: "#0f172a",
              cursor: "pointer",
              boxShadow: "0 3px 10px rgba(15,23,42,.06)",
            }}
          >
            Close
          </button>
        </div>

        <div
          style={{
            padding: 10,
            overflowY: "auto",
            display: "grid",
            gap: 7,
            background: "#f8fafc",
          }}
        >
          {overflowPanel.map((shift) => (
            <PlannerShiftCard
              key={shift.id}
              shift={shift}
              compactHeight={82}
              now={now}
              selectedShiftId={selectedShiftId}
              selectedShiftIds={selectedShiftIds}
              toggleShiftSelection={toggleShiftSelection}
              setSelectedShiftId={setSelectedShiftId}
              workersByUid={workersByUid}
              shortWorkerLabel={shortWorkerLabel}
              LifecycleBoxes={LifecycleBoxes}
            />
          ))}
        </div>
      </div>
    </div>
  );
}